import axios from "axios";
import history from "utils/History";

export const origin = `${process.env.REACT_APP_DNERHS_API_PROTOCOL}://${process.env.REACT_APP_DNERHS_API_HOST}`;

export const CancelToken = axios.CancelToken;

const instance = axios.create({
  baseURL: origin,
  timeout: 60000,
  headers: { "Content-Type": "application/json" },
});
instance.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("dnerhs-jwt");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (err) {
    return Promise.reject(err);
  }
);

// Interceptor para llamar a refreshToken cuando el access token vence.
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.group("🚨 Error interceptado por DnerhsApi");
    console.error("Error completo:", error);

    if (error.response) {
      let status = error.response.status;
      console.error("Status:", status);
      console.error("Data:", error.response.data);
      console.error("Headers:", error.response.headers);

      switch (status) {
        case 401:
          console.warn("Token expirado, redirigiendo al login");
          localStorage.removeItem("dnerhs-jwt");
          history.push(`/login`);
          break;
        case 403:
          console.warn("Acceso prohibido, redirigiendo a forbidden");
          history.push(`/forbidden`);
          break;
        case 500:
          console.error("Error interno del servidor detectado");
          // Agregar información adicional para debugging
          if (error.response.data) {
            console.error("Detalles del error 500:", error.response.data);
          }
          break;
        default:
          console.warn(`Error HTTP ${status} no manejado específicamente`);
          break;
      }
    } else if (error.request) {
      console.error("Error de red - no se recibió respuesta:", error.request);
    } else {
      console.error("Error de configuración:", error.message);
    }

    console.groupEnd();
    return Promise.reject(error);
  }
);

export default instance;
